import visitedQuestionsActions from '../actions/VisitedQuestionsActions';

// Questions are added as they get viewed. There should be no false values.
export const defaultState = {};

function visitedQuestions(state = defaultState, action) {
    switch (action.type) {
    case visitedQuestionsActions.types.VISITED_QUESTIONS_SET_VISITED:
        if (!state[action.contentRevisionId]) {
            return Object.assign({}, state, { [action.contentRevisionId]: true });
        }

        return state;
    default:
        return state;
    }
}

export default visitedQuestions;
